<div class="gt-routes-list-containerss height-limit" style="overflow:scroll">

    <ng-container *ngIf="!emailTemplateEditorVisible">
        <dx-data-grid [dataSource]="allEmailTemplatesList" showBorders="true"
            class="gt-data-grid-style  gt-grid-left-top-corner-round" rowAlternationEnabled="true"
            hoverStateEnabled="true" width="auto" [allowColumnResizing]="true" [columnResizingMode]="'widget'"
            [columnAutoWidth]="false" [showBorders]="true" [scrolling]="{ mode: 'standard', useNative: true }"
            [width]="'100%'">
            <dxo-search-panel [visible]="true" class="gt-search-panel" width="17vw"></dxo-search-panel>
            <dxo-scrolling mode="virtual"></dxo-scrolling>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <!--             <dxo-editing [allowUpdating]="userPermissions" [allowDeleting]="userPermissions" mode="row"
                [confirmDelete]="false" [useIcons]="true"></dxo-editing>(onEditingStart)="editRow($event)"
            (onRowRemoving)="deleteTemlpate($event)" -->
            <dxo-toolbar>
                <dxi-item name="searchPanel" location="before"></dxi-item>
                <dxi-item location="after">
                    <div class="gt-flex-dir-row">
                        <dx-button class="gt-button gt-btn-right gt-blk-txt add-button " icon="add"
                            i18n-text="@@newEmailTemplateCaps" text="New Email Template" (onClick)="addEmailTemplate()">
                        </dx-button>
                    </div>
                </dxi-item>
            </dxo-toolbar>

            <dxi-column alignment="left" dataField="templateId" i18n-caption caption="Template ID"></dxi-column>
            <dxi-column dataField="mailSubject" i18n-caption caption="Email Subject"></dxi-column>
            <dxi-column dataField="mailTo" i18n-caption caption="Repipients"></dxi-column>
            <dxi-column [visible]="userPermissions" cellTemplate="buttonCellTemplate" width="auto"
                [formItem]="{visible: false}">
            </dxi-column>
            <div *dxTemplate="let item of 'buttonCellTemplate'">
                <div class="cell-with-buttons">
                    <div class="cell-button-container">
                        <dx-button icon="edit" class="cell-button" (onClick)="editRow(item.data, item.rowIndex)">
                        </dx-button>
                        <dx-button icon="clear" class="cell-button"
                            (onClick)="deleteTemlpate(item.data, item.rowIndex)">
                        </dx-button>
                    </div>
                </div>
            </div>


        </dx-data-grid>

    </ng-container>


    <ng-container *ngIf="emailTemplateEditorVisible">
        <div class="scroll-min-width gt-flex-dir-row">
            <dx-html-editor [height]="windowHeight" [(value)]="valueContent" width="100%">
                <dxo-toolbar [multiline]="isMultiline">
                    <dxi-item name="undo"></dxi-item>
                    <dxi-item name="redo"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="size" [acceptedValues]="['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']"
                        [options]="{ inputAttr: { 'aria-label': 'Font size' } }"></dxi-item>
                    <dxi-item name="font" [acceptedValues]="[
        'Arial',
        'Courier New',
        'Georgia',
        'Impact',
        'Lucida Console',
        'Tahoma',
        'Times New Roman',
        'Verdana']" [options]="{ inputAttr: { 'aria-label': 'Font family' } }"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="bold"></dxi-item>
                    <dxi-item name="italic"></dxi-item>
                    <dxi-item name="strike"></dxi-item>
                    <dxi-item name="underline"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="alignLeft"></dxi-item>
                    <dxi-item name="alignCenter"></dxi-item>
                    <dxi-item name="alignRight"></dxi-item>
                    <dxi-item name="alignJustify"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="orderedList"></dxi-item>
                    <dxi-item name="bulletList"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="header" [acceptedValues]="[false, 1, 2, 3, 4, 5]"
                        [options]="{ inputAttr: { 'aria-label': 'Header' } }"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="color"></dxi-item>
                    <dxi-item name="background"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="link"></dxi-item>
                    <dxi-item name="image"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="clear"></dxi-item>
                    <dxi-item name="codeBlock"></dxi-item>
                    <dxi-item name="blockquote"></dxi-item>
                    <dxi-item name="separator"></dxi-item>
                    <dxi-item name="insertTable"></dxi-item>
                    <dxi-item name="deleteTable"></dxi-item>
                    <dxi-item name="insertRowAbove"></dxi-item>
                    <dxi-item name="insertRowBelow"></dxi-item>
                    <dxi-item name="deleteRow"></dxi-item>
                    <dxi-item name="insertColumnLeft"></dxi-item>
                    <dxi-item name="insertColumnRight"></dxi-item>
                    <dxi-item name="deleteColumn"></dxi-item>


                    <!--                 <dxi-item>
                    <div *dxTemplate>
                        <dx-drop-down-box>
                            <dxo-drop-down-options [height]="300" [width]="700"> </dxo-drop-down-options>
                        </dx-drop-down-box>
                    </div>
                </dxi-item> -->
                </dxo-toolbar>
                <dxo-table-context-menu [enabled]="true">
                </dxo-table-context-menu>
                <dxo-media-resizing [enabled]="true"> </dxo-media-resizing>
                <dxo-image-upload fileUploadMode="both" [tabs]="['url', 'file']" fileUploadMode="base64"
                    uploadDirectory="/Images" uploadUrl="https://js.devexpress.com/Demos/Upload">
                </dxo-image-upload>

                <dxi-mention valueExpr="text" displayExpr="displayText" searchExpr="text"
                    [dataSource]="predefinedOptions"></dxi-mention>
            </dx-html-editor>

        </div>
        <div class="gt-flex-dir-row space-between">
            <dx-button i18n-text text="CANCEL" class="gt-button gt-bottom gt-btn-left "
                (onClick)="cancel()"></dx-button>
            <dx-button i18n-text text="SAVE" class="gt-button gt-bottom gt-btn-right gt-primary"
                (onClick)="save()"></dx-button>
        </div>
    </ng-container>
</div>

<dx-popup [visible]="popupActive" title="Please add your email details." width="800" height="auto"
    (onHiding)="popupActive = false">
    <dx-form [formData]="emailData" [colCount]="2" width="100%">
        <dxi-item itemType="group">

            <dxi-item [colSpan]="2">
                <dxo-label i18n-text text="Email Subject"></dxo-label>
                <div *dxTemplate="'emailSubjectTemplate'">
                    <dx-text-box [(value)]="emailData.subject" width="100%">
                    </dx-text-box>
                </div>
            </dxi-item>
            <dxi-item [colSpan]="2">
                <dxo-label i18n-text text="Email Recipients"></dxo-label>
                <div *dxTemplate="'emailRecipientsTemplate'">
                    <!--                     <dx-tag-box [(value)]="emailData.recipients" [items]="recipientsList" displayExpr="displayName"
                        multiline="true" applyValueMode="useButtons" valueExpr="email" [searchEnabled]="true"
                        searchMode="contains" (onValueChanged)="logRecipientsList($event)">
                    </dx-tag-box> -->

                    <dx-text-box width="100%" [(value)]="emailData.recipients"></dx-text-box>
                </div>
            </dxi-item>
        </dxi-item>
    </dx-form>
    <div class="gt-flex-dir-row space-between">
        <dx-button i18n-text text="BACK" class="gt-button gt-bottom gt-btn-left "
            (onClick)="backToTemplateEditor()"></dx-button>
        <dx-button text="SAVE" class="gt-button gt-bottom gt-btn-right gt-primary"
            (onClick)="saveEmailData()"></dx-button>
    </div>
</dx-popup>

<app-delete-popup [visible]="deleteEmailTemplateConfirmVisible" i18n-message="@@deleteEmailTemplateMessage"
    message="Do you want to delete this Email Template?" (onConfirm)="handleDelete($event)"
    (onAbort)="deleteEmailTemplateConfirmVisible = false"></app-delete-popup>